module.exports = __webpack_public_path__ + "static/media/headphone-alt.73102c06.svg";